

<h2>Trends for {{siteName}}</h2>
<app-tabs (tabActivated)="onTabActivated($event)">

    <app-tab label="Monthly" [active]="true">
        <!-- attributes chart, table & keyupdates are select attributes for ng-content in app-site-content-widget -->
        <app-site-content-widget [title]="'Enterococci'" 
            [showExportButton]="true"
            [briefDescription]="monitoringDetailsText"
            [tooltip]=" {heading : 'How do we measure this?', target : '' }"
            [chartTitle]="'Colony forming units per 100ml'" 
            [data]="monthlyTrendsData"
            (ExportDataClick)="onExportDataClicked('Monthly')" >

                 <!-- attributes chart, table & keyupdates are select attributes for ng-content in app-site-content-widget -->
                 <div chart>
                    <ng-container *ngIf="0 === activeTabIndex">
                        <app-google-charts-scatter-chart chart
                            [chartData]="monthlyChartData" 
                            [chartOptions]="monthlyChartOptions">
                        </app-google-charts-scatter-chart>  
                    </ng-container>
                 </div>

                <div class="nsw-table nsw-table--striped nsw-table--bordered" table
                    [tabindex]="0" *ngIf="monthlyTrendsData?.[0].length > 1">
                    <table>    
                        <thead style="display:none">
                            <tr>
                                <th></th>
                                <th [attr.colspan]="monthlyTrendsData?.[0].length - 1"></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td [class]="'nowrap-text '+ (0 === j ? 'left-aligned-text' : 'centre-aligned-text')" 
                                    *ngFor="let item of monthlyTrendsData?.[0], let j = index">
                                    {{null == monthlyTrendsData?.[0]?.[j] ? "" : monthlyTrendsData?.[0]?.[j]}}
                                </td>
                            </tr> 
                            <tr>
                                <td [class]="'nowrap-text '+ (0 === j ? 'left-aligned-text' : 'centre-aligned-text')"
                                    *ngFor="let item of monthlyTrendsData?.[1], let j = index">
                                    {{(null == monthlyTrendsData?.[1]?.[j] || "" === monthlyTrendsData?.[1]?.[j])  ? "" : monthlyTrendsData?.[1]?.[j]}}
                                </td>
                            </tr>  
                        </tbody>
                    </table>
                </div>
               

                <app-key-popup-widget [description]="'How do we measure this?'" [popupTitle]="'How do we measure this?'" keyupdates>
                    <app-key-sitetrends-popup-content-widget></app-key-sitetrends-popup-content-widget>
                </app-key-popup-widget>               
                
            </app-site-content-widget>
    </app-tab>

    <app-tab label="Annual" [active]="false">
        <!-- attributes chart, table & keyupdates are select attributes for ng-content in app-site-content-widget -->
        <app-site-content-widget [title]="'Enterococci'" 
            [showExportButton]="true"
            [briefDescription]="monitoringDetailsText"
            [tooltip]=" {heading : 'How do we measure this?', target : '' }"
            [chartTitle]="'Colony forming units per 100ml'"
            [data]="annualTrendsData"
            (ExportDataClick)="onExportDataClicked('Annual')" >    
        
            <!-- attributes chart, table & keyupdates are select attributes for ng-content in app-site-content-widget -->

            <div chart>
                <ng-container *ngIf="1 === activeTabIndex">
                    <app-google-charts-scatter-chart chart
                        [chartData]="annualChartData" 
                        [chartOptions]="annualChartOptions">
                    </app-google-charts-scatter-chart>
                </ng-container>
            </div>
            
            <div class="nsw-table nsw-table--striped nsw-table--bordered" table
                [tabindex]="0" *ngIf="annualTrendsData?.[0].length > 1">
                <table>    
                    <thead style="display:none">
                        <tr>
                            <th></th>
                            <th [attr.colspan]="annualTrendsData?.[0].length - 1"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td [class]="'nowrap-text '+ (0 === j ? 'left-aligned-text' : 'centre-aligned-text')" 
                                *ngFor="let item of annualTrendsData?.[0], let j = index">
                                {{null == annualTrendsData?.[0]?.[j] ? "" : annualTrendsData?.[0]?.[j]}}
                            </td>
                        </tr> 
                        <tr>
                            <td [class]="'nowrap-text '+ (0 === j ? 'left-aligned-text' : 'centre-aligned-text')"
                                *ngFor="let item of annualTrendsData?.[1], let j = index">
                                {{(null == annualTrendsData?.[1]?.[j] || "" === annualTrendsData?.[1]?.[j])  ? "" : annualTrendsData?.[1]?.[j]}}
                            </td>
                        </tr>  
                    </tbody>
                </table>
            </div>
            
            <app-key-popup-widget [description]="'How do we measure this?'" [popupTitle]="'How do we measure this?'" keyupdates>
                <app-key-sitetrends-popup-content-widget></app-key-sitetrends-popup-content-widget>                  
            </app-key-popup-widget>                  

        </app-site-content-widget>
    </app-tab>
</app-tabs>